import {
  Alert,
  AlertIcon,
  Heading,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import Container from '../components/Container';
import { getInfo } from '../services';

const ErrorPage = () => {
  const [fields, setFields] = useState([]);

  useEffect(() => {
    const [rta, abortController] = getInfo();
    rta.then((data) => {
      if (data) {
        const f = data[0]?.map || {};
        const f1 = Object.entries(f).map(([name, value]) => ({ name, value }));
        setFields(f1);
      }
    });
    return () => abortController.abort();
  }, []);

  return (
    <Container py="8">
      <Heading fontSize="sm" color="gray.600">
        Error page
      </Heading>

      {fields.map((item, idx) => (
        <Alert status="error" key={idx} my="6">
          <AlertIcon />
          {item.value}
        </Alert>
      ))}
    </Container>
  );
};

export default ErrorPage;
